import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { Navigate, Outlet, RouteProps } from "react-router-dom";

export const PublicRoute: React.FC<RouteProps> = () => {
  const { route, authStatus} = useAuthenticator((context) => [
    context.route,
  ]);
  useEffect(()=>{

    console.log(`authStatus:${authStatus}`)
    if(authStatus === "authenticated") console.log("redirect to top page")
  },[authStatus])
  return authStatus === "authenticated" ? <Navigate to="/"/> : <Outlet/>
};
